import { DashboardConfig } from './api';

async function login(identifier, password) {
  const response = await fetch(`${DashboardConfig.apiBaseUrl}/api/auth/login`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ identifier, password }),
  });

  let payload = null;
  const text = await response.text();
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch (error) {
      console.warn('[AuthApi] Failed to parse login response', error);
    }
  }

  if (!response.ok) {
    const message = payload?.error || payload?.message || 'Kunne ikke logge inn';
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  if (!payload || !payload.token) {
    throw new Error('Ugyldig svar fra innloggingstjenesten.');
  }

  return payload;
}

async function register(payload = {}) {
  const response = await fetch(`${DashboardConfig.apiBaseUrl}/api/accounts/register`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  let body = null;
  const text = await response.text();
  if (text) {
    try {
      body = JSON.parse(text);
    } catch (error) {
      console.warn('[AuthApi] Failed to parse register response', error);
    }
  }

  if (!response.ok) {
    const message = body?.error || body?.message || 'Kunne ikke registrere konto';
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return body;
}

async function getPartnerInvite(inviteToken) {
  const token = typeof inviteToken === 'string' ? inviteToken.trim() : '';
  if (!token) {
    throw new Error('invite_token mangler');
  }

  const response = await fetch(
    `${DashboardConfig.apiBaseUrl}/api/accounts/partner-invite?invite_token=${encodeURIComponent(token)}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
  );

  const text = await response.text();
  let body = null;
  if (text) {
    try {
      body = JSON.parse(text);
    } catch {
      body = null;
    }
  }

  if (!response.ok) {
    const message = body?.error || body?.message || 'Invitasjonen er ikke gyldig.';
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return body;
}

async function exchangePartnerDemoSession(sessionToken) {
  const token = typeof sessionToken === 'string' ? sessionToken.trim() : '';
  if (!token) {
    throw new Error('partner_demo_session mangler');
  }

  const response = await fetch(`${DashboardConfig.apiBaseUrl}/api/auth/partner-demo/session/exchange`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  });

  const text = await response.text();
  let body = null;
  if (text) {
    try {
      body = JSON.parse(text);
    } catch {
      body = null;
    }
  }

  if (!response.ok) {
    const message = body?.error || body?.message || 'Kunne ikke åpne demo-sesjonen.';
    const error = new Error(message);
    error.status = response.status;
    error.code = body?.code || null;
    error.details = body || null;
    throw error;
  }

  if (!body?.token || !body?.user) {
    throw new Error('Ugyldig svar fra sesjonstjenesten.');
  }

  return body;
}

export const AuthApi = {
  login,
  register,
  getPartnerInvite,
  exchangePartnerDemoSession,
};
